import {Collapse, Grid} from '@mui/material';
import {memo, useState, useCallback} from 'react';

import MhdSelect from '../../atomicComponents/MhdSelect';
import MhdLineWidthChoices from '../../atomicComponents/MhdLineWidthChoices';
import MhdMarkerSymbolChoices from '../../atomicComponents/MhdMarkerSymbolChoices';
import MhdLineStyleChoices from '../../atomicComponents/MhdLineStyleChoices';
import MhdInput from '../../atomicComponents/MhdInput';
import MhdRadioButton from '../../atomicComponents/MhdRadioButton';
import MhdSolidColorWidget from '../../atomicComponents/MhdSolidColorWidget';
import MhdSwitch from '../../atomicComponents/MhdSwitch';
import MhdWidgetDivider from '../../atomicComponents/MhdWidgetDivider';
import {sliceChoices, unitChoices} from '../../../utils/choices';
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";

const SliceWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <MhdSelect
          label='Slice'
          value={data.slice}
          onChange={useCallback((v) => setAndUpdate('slice', v, setter, update), [])}
          choices={sliceChoices}
        />
      </Grid>
      <Grid item xs={6}>
        <MhdInput
          label={data.slice === 'r' ? 'Latitude' : 'Radius'}
          value={data.slice_param1}
          override={mods.slice_param1}
          warning={warn.slice_param1}
          error={errs.slice_param1}
          onChange={useCallback((v) => validateAndUpdate('slice_param1', v, setter, update), [])}
          units={data.slice === 'r' ? '°' : 'R⊙'}

        />
      </Grid>
      <Grid item xs={6}>
        <MhdInput
          label={data.slice === 'p' ? 'Latitude' : 'Longitude'}
          value={data.slice_param2}
          override={mods.slice_param2}
          warning={warn.slice_param2}
          error={errs.slice_param2}
          onChange={useCallback((v) => validateAndUpdate('slice_param2', v, setter, update), [])}
          units='°'
        />
      </Grid>
      <Grid item xs={4}>
        <MhdRadioButton
          label={'Log\u2081\u2080f(x)'}
          value={data.log_transform}
          override={mods.log_transform}
          warning={warn.log_transform}
          error={errs.log_transform}
          onChange={useCallback((v) => setAndUpdate('log_transform', v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={4}>
        <MhdRadioButton
          label={'⏐f(x)⏐'}
          value={data.abs_transform}
          override={mods.abs_transform}
          warning={warn.abs_transform}
          error={errs.abs_transform}
          onChange={useCallback((v) => setAndUpdate('abs_transform', v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={4}>
        <MhdRadioButton
          label={'f(x)・r\u207F'}
          value={data.rad_transform}
          override={mods.rad_transform}
          warning={warn.rad_transform}
          error={errs.rad_transform}
          onChange={useCallback((v) => setAndUpdate('rad_transform', v, setter, update), [])}
        />
        <Collapse in={mods.rad_transform !== undefined ? mods.rad_transform : data.rad_transform}>
          <MhdInput
            label={'n'}
            value={data.rad_transform_exponent}
            override={mods.rad_transform_exponent}
            warning={warn.rad_transform_exponent}
            error={errs.rad_transform_exponent}
            onChange={useCallback((v) => validateAndUpdate('rad_transform_exponent', v, setter, update), [])}
          />
        </Collapse>
      </Grid>

      <Grid item xs={12}>
        <MhdWidgetDivider
            label='CUSTOMIZE STYLE'
            value={customizeStyle}
            onChange={setCustomizeStyle}
        >
          <Collapse in={customizeStyle} >
            <Grid container spacing={1} pt={'2px'}>
              <Grid item xs={3}>
                <MhdSolidColorWidget
                  label='Line Color'
                  value={data.color}
                  onChange={useCallback((v) => setAndUpdate('color', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdMarkerSymbolChoices
                  label='Symbols'
                  value={data.marker_symbol}
                  onChange={useCallback((v) => setAndUpdate('marker_symbol', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdLineWidthChoices
                  label='Line Width'
                  value={data.line_width}
                  onChange={useCallback((v) => setAndUpdate('line_width', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdLineStyleChoices
                  label='Line Style'
                  value={data.line_style}
                  onChange={useCallback((v) => setAndUpdate('line_style', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdSelect
                  label='Units'
                  value={data.units}
                  onChange={useCallback((v) => setAndUpdate('units', v, setter, update), [])}
                  choices={unitChoices}
                />
              </Grid>
              <Grid item xs={3} />
              <Grid item xs={5}>
                <MhdSwitch
                  label='Show Text'
                  value={data.show_text}
                  onChange={useCallback((v) => setAndUpdate('show_text', v, setter, update), [])}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default memo(SliceWidget);